import React, { Dispatch, useState } from 'react';
import BaseSearch from './BaseSearch';
import type { Suggestion } from '../../types/search/Suggestion';
import { useQuery } from '@tanstack/react-query';
import { searchDairenProjectSuggestions } from '../../services/api';
import LoadingOverlay from '../LoadingOverlay';

interface ProjectSearchProps {
  setSelectedId: (id: number) => void;
  onSelectedLabel?: (label: string | null) => void;
}

const DairenProjectSearch = ({
  setSelectedId,
  onSelectedLabel,
}: ProjectSearchProps) => {
  const [query, setQuery] = useState('');

  const {
    data: results = [],
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['project-suggest', query],
    queryFn: () => searchDairenProjectSuggestions(query),
    // 自動実行オフ
    enabled: false,
  });

  const runSearch = async (currentValue: string) => {
    const q = currentValue.replace(/\s+/g, ''); // 空白除去
    setQuery(q);
    if (!q) return;
    await refetch();
  };

  return (
    <>
      <LoadingOverlay isLoading={isLoading} isMutating={false} />
      <BaseSearch<Suggestion>
        value={query}
        onChange={(e) => setQuery((prev) => e.target.value)}
        suggestions={results}
        onSelect={(item) => {
          setQuery(item.label);
          setSelectedId(item.value);
          onSelectedLabel?.(item.label);
        }}
        onEnter={runSearch}
        placeholder="プロジェクトを指定"
      />
      {error && (
        <div className="small text-danger mt-1">
          検索候補の取得に失敗しました
        </div>
      )}
    </>
  );
};

export default DairenProjectSearch;
